/**
 * @generated SignedSource<<6db69c0db700b6877ab0dc97cac6a990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MainCreateModelListMutation$variables = Record<PropertyKey, never>;
export type MainCreateModelListMutation$data = {
  readonly createModelList: {
    readonly modelList: {
      readonly id: string;
    };
  };
};
export type MainCreateModelListMutation = {
  response: MainCreateModelListMutation$data;
  variables: MainCreateModelListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreateModelListPayload",
    "kind": "LinkedField",
    "name": "createModelList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelList",
        "kind": "LinkedField",
        "name": "modelList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MainCreateModelListMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MainCreateModelListMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e728b7c03f2e7fa4541c7fd239af6483",
    "id": null,
    "metadata": {},
    "name": "MainCreateModelListMutation",
    "operationKind": "mutation",
    "text": "mutation MainCreateModelListMutation {\n  createModelList {\n    modelList {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a11407e76b5894f4c83da242768e2b89";

export default node;
